<template>
    <div>
        <h4>Capital et valeur des parts</h4>

        <b-card no-body class="shadow-sm mb-3">
            <b-card-body>
                <div class="row">
                    <b-col sm="4" class="pr-1">
                        <label class="mt-1 small">Capital (en €)</label>
                        <b-input
                            v-model="form.asset"
                            size="sm"
                            class="mb-1 text-right"
                            :state="!$v.form.asset.$invalid"
                            @input="calculateShareValue"
                        />
                    </b-col>

                    <b-col sm="4" class="pr-1 pl-1">
                        <label class="mt-1 small">Nombre de parts</label>
                        <b-input
                            :key="sharesKey"
                            v-model="form.shares"
                            size="sm"
                            class="mb-1 text-right"
                            :state="!$v.form.shares.$invalid"
                            @input="calculateShareValue"
                        />
                    </b-col>

                    <b-col sm="4" class="pl-1">
                        <label class="mt-1 small"
                            >Valeur de la part (en €)</label
                        >
                        <b-input
                            :key="shareValueKey"
                            v-model="form.share_value"
                            size="sm"
                            class="mb-1 text-right"
                            :state="!$v.form.share_value.$invalid"
                            @input="calculateShares"
                        />
                    </b-col>
                </div>
                <b-alert
                    variant="success"
                    :show="showSavedAlert && !$v.$invalid"
                    class="mb-0 mt-2"
                >
                    Les modifications ont bien été enregistrées
                </b-alert>
                <b-alert
                    variant="danger"
                    :show="showNotSavedAlert && !$v.$invalid"
                    class="mb-0 mt-2"
                >
                    Une erreur s'est produite, les modifications ne sont pas
                    enregistrées
                </b-alert>
                <b-alert variant="danger" :show="$v.$invalid" class="mb-0 mt-2">
                    Les données ne sont pas valides
                </b-alert>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { decimal, numeric, required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

export default {
    name: 'AssetHandler',

    data() {
        return {
            form: {
                asset: 0,
                shares: 0,
                share_value: 0,
            },
            key: Date.now(),
            shareValueKey: `svk${Date.now()}`,
            sharesKey: `shk${Date.now()}`,
            showSavedAlert: false,
            showNotSavedAlert: false,
            init: true,
        }
    },

    validations: {
        form: {
            asset: { required, decimal },
            shares: { required, numeric },
            share_value: { required, decimal },
        },
    },

    created() {
        this.form.asset = this.client.asset
        this.form.shares = this.client.shares
        this.calculateShareValue()
        this.init = false
    },

    methods: {
        showNotSaved() {
            this.showSavedAlert = false
            this.showNotSavedAlert = true
        },

        showSaved() {
            this.showSavedAlert = true
            this.showNotSavedAlert = false
        },

        async updateAsset() {
            if (!this.submitIsDisabled) {
                try {
                    const response = await axios.put(
                        `/clients/${this.client.id}/asset`,
                        this.form
                    )
                    this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                    this.showSaved()
                } catch (error) {
                    // handle error
                    this.showNotSaved()
                    console.log(error)
                }
            }
        },

        calculateShareValue() {
            let share_value = 0
            if (parseInt(this.form.shares) > 0) {
                share_value = this.form.asset / parseInt(this.form.shares)
            }
            this.form.share_value = share_value.toFixed(2)
            this.shareValueKey = `svk${Date.now()}`
            if (!this.init) {
                this.updateAsset()
            }
        },

        calculateShares() {
            this.form.shares = this.form.asset / parseInt(this.form.share_value)
            this.sharesKey = `shk${Date.now()}`
            this.updateAsset()
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
        }),

        submitIsDisabled() {
            return this.$v.$invalid
        },
    },
}
</script>

<style scoped></style>
